import type { LucideIcon } from 'lucide-react'

export type PlatformApp = 'shell' | 'pac' | 'discovery' | 'identity' | 'polix-ai' | 'analytics' | 'docs'

export interface PlatformAppConfig {
  readonly id: PlatformApp
  readonly displayName: string
  readonly description: string
  readonly iconName: string
  readonly basePath: string
}

export const PLATFORM_APPS: Record<PlatformApp, PlatformAppConfig> = {
  shell: {
    id: 'shell',
    displayName: 'poli-x Platform',
    description: 'Enterprise Security Platform',
    iconName: 'Shield',
    basePath: '/',
  },
  pac: {
    id: 'pac',
    displayName: 'Policy Admin Console',
    description: 'Create, manage, and deploy XACML ABAC policies',
    iconName: 'FileText',
    basePath: '/pac',
  },
  discovery: {
    id: 'discovery',
    displayName: 'Data Discovery',
    description: 'Connect to databases and classify sensitive data',
    iconName: 'Search',
    basePath: '/discovery',
  },
  identity: {
    id: 'identity',
    displayName: 'Identity Store',
    description: 'User attributes, IdP sync, and identity management',
    iconName: 'Users',
    basePath: '/identity',
  },
  'polix-ai': {
    id: 'polix-ai',
    displayName: 'poli-x - AI',
    description: 'AI-powered security assistant with reasoning and tools',
    iconName: 'BotMessageSquare',
    basePath: '/polix-ai',
  },
  analytics: {
    id: 'analytics',
    displayName: 'Analytics & Reporting',
    description: 'Audit logs, access decisions, reports, and security analytics',
    iconName: 'BarChart3',
    basePath: '/pac/analytics',
  },
  docs: {
    id: 'docs',
    displayName: 'Documentation',
    description: 'Learn ABAC, XACML, and how poli-x works',
    iconName: 'GraduationCap',
    basePath: '/docs',
  },
}

export interface NavItem {
  readonly title: string
  readonly url: string
  readonly icon: LucideIcon
}
